export default "__VITE_ASSET__BIJ3vQqH__"